import { Pagination } from '@b-design/fusion';

interface PaginationComponentProps {
  total: number;
  current: number;
  pageSize?: number;
  onPageChange: (current: number, pageSize: number) => void;
  pageSizeSelector?: any;
}

const PaginationComponent = ({
  current,
  pageSize = 10,
  onPageChange,
  total,
  pageSizeSelector = 'dropdown',
}: PaginationComponentProps) => {
  const handlePageChange = (newCurrent: number, newPageSize: number) => {
    onPageChange(newCurrent, newPageSize);
  };

  return (
    <Pagination
      className="list-pagination"
      pageSizeSelector={pageSizeSelector}
      showJump={false}
      shape="no-border"
      total={total}
      current={current}
      pageSize={pageSize}
      onChange={(_current: number) => handlePageChange(_current, pageSize)}
      onPageSizeChange={(_pageSize: number) => handlePageChange(1, _pageSize)}
    />
  );
};

export default PaginationComponent;
